import { useState } from 'react';
export const usePersonalization = () => {
    const [enabled, setEnabled] = useState(false);
    const [text, setText] = useState('');
    const [textError, setTextError] = useState(null);
    const onToggle = (checked) => {
        setEnabled(checked);
        if (!checked)
            setTextError(null);
    };
    const onTextChange = (value) => {
        setText(value);
        if (value.trim())
            setTextError(null);
    };
    const validate = () => {
        if (enabled && !text.trim()) {
            setTextError('This field is required.');
            return false;
        }
        return true;
    };
    return { enabled, text, textError, onToggle, onTextChange, validate };
};
